import React from 'react';
import { FacebookAuthProvider, signInWithPopup } from "firebase/auth";
import { getAuth } from "firebase/auth";
import { BsFacebook } from 'react-icons/bs';
import { setUserInfo } from '../../features/user/userSlice';
import { useDispatch } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { useCreateTokenMutation } from '../../features/api/apiSlice';


const LoginWithFacebook = () => {
    const [createToken, { data: token, isError, isSuccess }] = useCreateTokenMutation();
    const dispatch = useDispatch();
    const provider = new FacebookAuthProvider();

    const auth = getAuth();
    auth.languageCode = 'it';
    provider.setCustomParameters({
        'display': 'popup'
    });


    let navigate = useNavigate();
    let location = useLocation();

    let { from } = location.state || { from: { pathname: "/" } };

    // console.log('token', token, isError, isSuccess)
    const actionLoginFacebook = () => {
        signInWithPopup(auth, provider)
            .then((result) => {
                // The signed-in user info.
                const user = result.user;

                // This gives you a Facebook Access Token. You can use it to access the Facebook API.
                const credential = FacebookAuthProvider.credentialFromResult(result);
                const accessToken = credential.accessToken;
                if (user) {
                    dispatch(setUserInfo(user));
                   
                    createToken({
                        email: user.email,
                        uid: user.uid,
                        name: user.displayName,
                        photo: user.photoURL
                    }) 
                    navigate(from);
                    // console.log(user)
                }
            })
            .catch((error) => {
                // Handle Errors here.
                const errorCode = error.code;
                const errorMessage = error.message;
                // The email of the user's account used.
                const email = error.customData.email;
                // The AuthCredential type that was used.
                const credential = FacebookAuthProvider.credentialFromError(error);

                // ...
            });
    }

    return (
        <div>
            {/* this is real btn  */}
            {/* <div onClick={actionLoginFacebook} className="opacity-20 hover:cursor-pointer w-full border py-2 my-1 rounded text-white bg-[#385591] text-xl font-poppins flex justify-center gap-4"><BsFacebook className='mt-1' /> Facebook</div> */}
            
            {/* it's disebol btn  */}
            <div className="opacity-20 hover:cursor-not-allowed w-full border py-2 my-1 rounded text-white bg-[#385591] text-xl font-poppins flex justify-center gap-4"><BsFacebook className='mt-1' /> Facebook</div>
        </div>
    );
};

export default LoginWithFacebook;